import { render, staticRenderFns } from "./tambahpohon.vue?vue&type=template&id=0d209da2&"
import script from "./tambahpohon.vue?vue&type=script&lang=js&"
export * from "./tambahpohon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports